(() => {
  'use strict';
  const configElement = document.getElementById('finks-accessibility-config');
  const config = configElement ? JSON.parse(configElement.textContent) : {};
  const hoverControls = new WeakSet();
  const namedLinks = new WeakSet();
  const hiddenControls = new WeakMap();
  const disabledPages = new WeakMap();
  const interactive = 'button, a[href], input, select, textarea, [role="button"], [role="checkbox"], [role="radio"]';

  function set(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function keyboardButton(element, label) {
    if (element.matches('button, input, select, textarea, a[href]')) return;
    if (!element.hasAttribute('role') || element.getAttribute('role') === 'presentation') set(element, 'role', 'button');
    set(element, 'tabindex', element.closest('[aria-hidden="true"], [inert]') ? '-1' : '0');
    if (label && !element.hasAttribute('aria-label') && !element.hasAttribute('aria-labelledby')) set(element, 'aria-label', label);
    if (element.hasAttribute('onkeydown')) return;
    set(element, 'onkeydown', "if(event.target===this&&!event.defaultPrevented&&!event.repeat&&(event.key==='Enter'||event.key===' ')){event.preventDefault();this.click();}");
  }

  function equivalentHover(element) {
    if (hoverControls.has(element)) return;
    hoverControls.add(element);
    if (element.hasAttribute('onmouseover') && !element.hasAttribute('onfocusin')) {
      element.addEventListener('focusin', () => element.dispatchEvent(new MouseEvent('mouseover')));
    }
    if (element.hasAttribute('onmouseout') && !element.hasAttribute('onfocusout')) {
      element.addEventListener('focusout', (event) => {
        if (!element.contains(event.relatedTarget)) element.dispatchEvent(new MouseEvent('mouseout'));
      });
    }
  }

  function repairMicrosite() {
    const root = document.getElementById('boss-dy-microsite-page-wrapper');
    if (!root) return;
    root.querySelectorAll('.boss-dy-microsite-item-thumb').forEach((card) => {
      const title = card.querySelector('.boss-dy-microsite-item-thumb-details-title')?.textContent.trim();
      if (!title) return;
      card.querySelectorAll('a[href]').forEach((link) => {
        if (!namedLinks.has(link) && (link.textContent.trim() || link.querySelector('img[alt]:not([alt=""])') || link.hasAttribute('aria-label') || link.hasAttribute('aria-labelledby'))) return;
        namedLinks.add(link);
        set(link, 'aria-label', title);
      });
    });

    root.querySelectorAll('[onclick*="boss_dy_microsite_click_size"], [onclick*="boss_dy_microsite_click_swatch"]').forEach((wrapper) => {
      const choices = wrapper.querySelectorAll('.boss-dy-microsite-size-wrapper[data-url], .boss-dy-microsite-swatch-wrapper[data-url]');
      if (!choices.length) return;
      wrapper.removeAttribute('role');
      wrapper.removeAttribute('tabindex');
      wrapper.removeAttribute('aria-label');
      choices.forEach((choice) => keyboardButton(choice));
    });

    root.querySelectorAll('.boss-dy-microsite-swatch-wrapper[data-url], .boss-dy-microsite-size-wrapper[data-url], .boss-dy-microsite-product-listing-drop-menu[onclick], .boss-dy-microsite-filter-value[onclick]').forEach((element) => keyboardButton(element));
    root.querySelectorAll('.boss-dy-microsite-filter-value[role="checkbox"]').forEach((element) => {
      set(element, 'aria-checked', String(element.classList.contains('boss_dy_microsite_selected')));
    });

    const name = root.querySelector('.boss-dy-microsite-item-details-name')?.textContent.trim() || config.viewProduct;
    root.querySelectorAll('.boss-dy-microsite-swatch-wrapper[data-url]').forEach((element) => {
      if (!/^Color:\s*$/.test(element.getAttribute('aria-label') || '')) return;
      const productName = element.closest('.boss-dy-microsite-item-thumb')?.querySelector('.boss-dy-microsite-item-thumb-details-title')?.textContent.trim() || name;
      if (productName) set(element, 'aria-label', [config.viewProduct, productName].filter(Boolean).join(': '));
    });
    root.querySelectorAll('#boss-dy-microsite-sort-options [data-id][onclick], [role="button"][onkeydown][onclick]').forEach((element) => {
      if (element.matches('.boss-dy-microsite-swatch-wrapper, .boss-dy-microsite-size-wrapper') || !element.querySelector(interactive)) keyboardButton(element);
    });
    root.querySelectorAll('.boss-dy-microsite-item-details-images-mode-full img[onclick], .boss-dy-microsite-item-details-images-mode-mobile img[onclick], .video-wrapper[onclick*="Show_Image_Lightbox"]').forEach((element, index) => {
      if (element.tagName === 'IMG' && !element.hasAttribute('alt')) set(element, 'alt', name || '');
      const label = [config.viewMedia, element.getAttribute('alt') || name, String(index + 1)].filter(Boolean).join(': ');
      keyboardButton(element, label);
      equivalentHover(element);
    });
    root.querySelectorAll('[onmouseover], [onmouseout]').forEach(equivalentHover);
    root.querySelectorAll('[role="tablist"]').forEach((element) => {
      if (!element.querySelector('[role="tab"]')) set(element, 'role', 'group');
    });
    root.querySelectorAll('nav[role="presentation"][aria-label]').forEach((element) => element.removeAttribute('role'));
    root.querySelectorAll('button[role="presentation"], button[role="none"]').forEach((element) => element.removeAttribute('role'));
    root.querySelectorAll('a[id="boss-dy-microsite-product-listing-nav-previous"], a[id="boss-dy-microsite-product-listing-nav-next"]').forEach((element) => {
      if (element.classList.contains('inactive')) {
        const saved = disabledPages.get(element) || { href: null, tabindex: element.getAttribute('tabindex') };
        if (element.hasAttribute('href')) saved.href = element.getAttribute('href');
        disabledPages.set(element, saved);
        element.removeAttribute('href');
        element.removeAttribute('tabindex');
        set(element, 'aria-disabled', 'true');
      } else if (disabledPages.has(element)) {
        const saved = disabledPages.get(element);
        if (!element.hasAttribute('href') && saved.href !== null) set(element, 'href', saved.href);
        if (!element.hasAttribute('tabindex') && saved.tabindex !== null) set(element, 'tabindex', saved.tabindex);
        if (element.getAttribute('aria-disabled') === 'true') element.removeAttribute('aria-disabled');
        disabledPages.delete(element);
      }
    });
  }

  function respectHiddenState(element) {
    if (element.getAttribute('aria-hidden') === 'true') {
      if (!element.inert) {
        hiddenControls.set(element, element.getAttribute('tabindex'));
        element.inert = true;
        if (element.tagName === 'IFRAME') set(element, 'tabindex', '-1');
      }
    } else if (hiddenControls.has(element)) {
      const tabindex = hiddenControls.get(element);
      element.inert = false;
      if (tabindex === null) element.removeAttribute('tabindex');
      else set(element, 'tabindex', tabindex);
      hiddenControls.delete(element);
    }
  }

  function repair() {
    document.querySelectorAll('.ss__show-more__link[data-finks-contrast], .ss__pagination__label[data-finks-contrast]').forEach((element) => element.removeAttribute('data-finks-contrast'));
    document.querySelectorAll('.ss__show-more__link, .ss__pagination__label.pagination__item--active').forEach((element) => {
      const style = getComputedStyle(element);
      if (style.backgroundColor === 'rgb(203, 170, 120)' && style.color === 'rgb(255, 255, 255)') {
        set(element, 'data-finks-contrast', 'gold-background');
      } else if (style.color === 'rgb(203, 170, 120)') {
        let ancestor = element;
        while (ancestor) {
          const background = getComputedStyle(ancestor).backgroundColor;
          if (background === 'rgb(255, 255, 255)') {
            set(element, 'data-finks-contrast', 'gold-text');
            break;
          }
          if (background !== 'rgba(0, 0, 0, 0)') break;
          ancestor = ancestor.parentElement;
        }
      }
    });
    document.querySelectorAll('select.ss__sort-by').forEach((element) => {
      if (!element.labels.length && !element.hasAttribute('aria-label') && !element.hasAttribute('aria-labelledby') && config.sortProducts) set(element, 'aria-label', config.sortProducts);
    });
    document.querySelectorAll('span[role="img"][data-acsb-sr-only="true"]').forEach((element) => {
      const label = element.textContent.trim();
      if (label && !element.hasAttribute('aria-label') && !element.hasAttribute('aria-labelledby')) set(element, 'aria-label', label);
    });
    document.querySelectorAll('a[role="button"][class*="pd-cp-"]:not([href])').forEach((element) => keyboardButton(element));
    document.querySelectorAll('#podium-bubble').forEach((element) => {
      if (element.title) element.removeAttribute('aria-label');
      respectHiddenState(element);
    });
    document.querySelectorAll('div[class*="fnks-2025-image-"][aria-hidden], div[class*="fnks-2025-image-"][inert]').forEach((element) => {
      if (element.querySelector(interactive) || hiddenControls.has(element)) respectHiddenState(element);
    });
    document.querySelectorAll('.gm-style div[aria-label]:is(:not([role]), [role="presentation"], [role="none"]), .gm-style span[aria-label]:is(:not([role]), [role="presentation"], [role="none"])').forEach((element) => set(element, 'role', 'group'));
    document.querySelectorAll('.gm-style button[role="button"], h1[role="heading"], h2[role="heading"], h3[role="heading"], h4[role="heading"], section[role="region"][aria-label][data-acsb-carousel]').forEach((element) => element.removeAttribute('role'));
    document.querySelectorAll('input[required][aria-required="true"], select[required][aria-required="true"], textarea[required][aria-required="true"]').forEach((element) => element.removeAttribute('aria-required'));
    document.querySelectorAll('.fnks-2025-contact-us button[disabled][aria-disabled]').forEach((element) => {
      element.removeAttribute('aria-disabled');
      element.removeAttribute('tabindex');
    });
    document.querySelectorAll('a[data-acsb-skip-link="content"][href="#acsbContent"], a[data-acsb-skip-link="content"][href="#MainContent"]').forEach((element) => {
      [element, ...element.querySelectorAll('.icon')].forEach((part) => {
        if (part.style.getPropertyValue('color') !== 'rgb(85, 26, 139)' || part.style.getPropertyPriority('color') !== 'important') part.style.setProperty('color', '#551a8b', 'important');
      });
    });
    repairMicrosite();
  }

  function start() {
    let pending = false;
    const options = { childList: true, subtree: true, attributes: true, characterData: true, attributeFilter: ['role', 'tabindex', 'aria-hidden', 'aria-label', 'aria-labelledby', 'aria-checked', 'aria-required', 'aria-disabled', 'href', 'class', 'required', 'disabled', 'style', 'onclick', 'onkeydown'] };
    const observer = new MutationObserver((records) => {
      const relevant = records.some((record) => {
        if (record.type === 'childList') return true;
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        return target && (target.closest('#boss-dy-microsite-page-wrapper, .gm-style, [class*="fnks-2025-image-"], [class*="pd-cp-"], #podium-bubble, .fnks-2025-contact-us, a[data-acsb-skip-link="content"]') || target.matches('select.ss__sort-by, .ss__show-more__link, .ss__pagination__label, span[data-acsb-sr-only], h1, h2, h3, h4, section[data-acsb-carousel], input[required], select[required], textarea[required]'));
      });
      if (!relevant || pending) return;
      pending = true;
      queueMicrotask(() => {
        pending = false;
        observer.disconnect();
        try { repair(); } finally { observer.observe(document.body, options); }
      });
    });
    repair();
    observer.observe(document.body, options);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
